module.exports = __webpack_public_path__ + "img/products/painting-premium-plus.png";